'use client'

/* eslint-disable @typescript-eslint/no-floating-promises */

import ErrorBoundary from '@components/ErrorBoundary/errorBoundary'
import Image from 'next/image'
import React, { useEffect, useState } from 'react'
import styles from './contactus.module.scss'
import { useObserver } from './utils/useObserver'

const ContactUs = ({ data, segmentEventCommonProperties, lob }) => {
  const [modalVisible, setModalVisible] = useState(false)
  const [DynamicComponent, setDynamicComponent] = useState<any>(null)
  const goUp = useObserver('productWidget', goUp => !goUp)

  const callIcon = data?.data?.attributes?.contactIcon?.data?.attributes?.url
  useEffect(() => {
    const importComponent = async () => {
      if (modalVisible) {
        document.documentElement.style.overflowY = 'hidden'
        const dynamicImportedComponent = await import('./ContactModal')
        setDynamicComponent({ Default: dynamicImportedComponent.default })
      } else document.documentElement.style.overflowY = 'scroll'
    }
    importComponent()
  }, [modalVisible])
  const contactUsData = data?.data?.attributes
  const handleModalVisibility = (visibility: boolean) => {
    setModalVisible(visibility)
  }
  return (
    <ErrorBoundary>
      <>
        <div
          className={`${styles.connectWithUsButtonWrapper} ${goUp ? styles.goUp : styles.goDown}`}
          onClick={() => handleModalVisibility(true)}>
          <div className={styles.connectWithUsIconWrapper}>
            <Image src={callIcon} alt="Call us" width={32} height={32} layout="responsive" />
          </div>
          <span className={styles.connectButtonText}>{contactUsData?.iconText || 'Connect with us'}</span>
        </div>

        {modalVisible && DynamicComponent?.hasOwnProperty('Default') ? (
          <DynamicComponent.Default
            data={data}
            modalVisible={modalVisible}
            setModalVisible={handleModalVisibility}
            segmentEventCommonProperties={segmentEventCommonProperties}
            lob={lob}
          />
        ) : null}
      </>
    </ErrorBoundary>
  )
}
export default ContactUs
